module.exports = __webpack_public_path__ + "img/typography-icon.f951a779.svg";